import React from 'react';
import { Input, InputNumber, Space } from 'antd';
import styles from '../../../event-timeline.module.css';

const { TextArea } = Input;

interface DisplayTextParamsProps {
  params: any;
  setParams: (params: any) => void;
}

const DisplayTextParams: React.FC<DisplayTextParamsProps> = ({
  params,
  setParams,
}) => {
  return (
    <div className={styles.parameterContainer}>
      <Space direction='vertical' style={{ width: '100%' }}>
        <span>Text:</span>
        <TextArea
          value={params.text || ''}
          onChange={(e) => setParams({ ...params, text: e.target.value })}
          placeholder='Enter text to display'
          rows={3}
        />
        <span>Duration (ms):</span>
        <InputNumber
          value={params.duration || 3000}
          onChange={(value) => setParams({ ...params, duration: value })}
          min={0}
          style={{ width: '100%' }}
        />
      </Space>
    </div>
  );
};

export default DisplayTextParams;
